import { SelectChangeEvent, Stack } from "@mui/material"
import { TDashboard, TDashboardFilters } from "./types"
import "./styles.scss"
import { ContentSectionContainer, EStorageType, FullBar, GenericWrapperContext, getStorage, Header, clearStorage, deleteStorageItem, setStorage } from "@cakemail-org/ui-components-v2"
import { DashboardContext } from "./context"
import { useContext, useEffect, useRef, useState } from "react"
import { WidgetsProvider } from "../../components/widgets"
import { AudienceGrowthWidget } from "../../components/widgets/audienceGrowth"
import { DateRangeDD } from "../../components/dateRangeDropdown"
import { getCurrentStoredFilters, setCurrentStoredFilters } from "../../utils/components"
import { useTranslation } from "react-i18next"
import { Banner } from "../../components/Banner"
import moment from "moment"
import { EStorageKeys } from "../../types/storage"

const dashboardPageStructureKey = "dashboardPageStructure"
export function Dashboard({ }: TDashboard) {
    const genericWrapper = useContext(GenericWrapperContext)
    const { t, i18n } = useTranslation()
    const filterStorageKey = "dashboardFilters"
    const initFilters: TDashboardFilters = getCurrentStoredFilters<TDashboardFilters>({ key: filterStorageKey, accountId: String(genericWrapper.account?.id) })

    const [isEditMode, setIsEditMode] = useState<boolean>(false)
    const [timeRange, setTimeRange] = useState<string>(initFilters?.timeRange || "7d")
    const [loading, setLoading] = useState<boolean>(false)

    const seenBanner = getStorage({ key: EStorageKeys.welcomeBannerSeen, type: EStorageType.session })
    const firstTimeBanner = useRef(false)
    const hasSeenBanner = useRef(seenBanner)

    useEffect(() => {
        const comingFromOnboarding = getStorage({ key: EStorageKeys.justCompletedOnboarding })

        if (comingFromOnboarding) {
            firstTimeBanner.current = true
            deleteStorageItem({ key: EStorageKeys.justCompletedOnboarding })
        }

        if (!seenBanner) {
            setStorage({ key: EStorageKeys.welcomeBannerSeen, data: true, type: EStorageType.session })
        }
    }, [])

    function setFilterStorage({ ...filters }: Partial<TDashboardFilters> = {}) {
        setCurrentStoredFilters<TDashboardFilters>({
            key: filterStorageKey,
            accountId: Number(genericWrapper.account?.id),
            data: {
                timeRange: filters.timeRange || timeRange,
            }
        })
    }

    function handleChangeEditMode() {
        setIsEditMode(!isEditMode)
    }

    function handleRangeChange(event: SelectChangeEvent<string>) {
        const { name, value } = event.target
        setTimeRange(value)
        setFilterStorage({ timeRange: value })
    }

    const hours = moment().hours()
    const stringExtra = { resellerName: genericWrapper.account?.name, firstName: genericWrapper.user?.first_name }

    let welcomeText = t("general-morning-welcome", stringExtra)
    if (hours >= 12 && hours < 18) {
        welcomeText = t("general-afternoon-welcome", stringExtra)
    } else if (hours >= 18) {
        welcomeText = t("general-evening-welcome", stringExtra)
    }

    return <ContentSectionContainer className="dashboardContainer">
        {!hasSeenBanner.current &&
            <Banner
                sx={{
                    width: "calc(100% + 2rem)",
                    marginLeft: "-2rem",
                    marginTop: "-2rem",
                }}
                text={<>
                    {firstTimeBanner.current ? <><b>{t("general-welcome-to-app", stringExtra)}</b> {t("dashboard-welcome-to-txt")}</>
                        :
                        <><b>{welcomeText}</b> {t("dashboard-welcome-back-txt", stringExtra)}</>}
                </>}
            />
        }

        <DashboardContext.Provider value={{

        }}>
            <FullBar
                className={loading ? "loading" : ""}
                left={<Header
                    heading={t("dashboard-heading")}
                    headingVariant="titleL"
                    support={genericWrapper.account?.name}
                />}
                right={[
                    <DateRangeDD
                        key="email-api-heading-timeRange"
                        onChange={handleRangeChange}
                        value={String(timeRange)}
                    />
                ]}
            />

            <WidgetsProvider
                initLayout={undefined}
                isEditMode={isEditMode}
                timeRange={timeRange}
                name="dashboard"
            />
        </DashboardContext.Provider>
    </ContentSectionContainer>
}